<template>
    <section class="main-content lottery-page pb-5">
        <div class="announce-bar" v-if="marquee_text">
            <div class="announce-bar__inner">
                <span class="announce-bar__label">
                    <i class="fa fa-bullhorn"></i>
                    ประกาศ
                </span>
                <div class="announce-bar__ticker">
                    <div class="announce-bar__track">
                        <span>{{ marquee_text }}</span>
                        <span>{{ marquee_text }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="lottery-content p-2 w-100 align-self-stretch" style="min-height: calc((100vh - 149.8px) - 50px);">
                <div class="lotto-section xtarget col-lotto">
                    <div class="section-title-wrap">
                        <h3 class="section-title">หวย</h3>
                    </div>

                    <div class="row">
                        <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 lotto-type-box">
                            <vue-countdown-timer
                                :start-time="start_time"
                                :end-time="gov_round.end"
                                :show-zero="false"
                                :interval="1000"
                                v-if="gov_round && gov_round.id"
                            >
                                <template slot="countdown" slot-scope="scope">
                                    <router-link :to="{ name: 'govhome', params: { round: gov_round.round } }">
                                        <div class="lotto-card lotto-card--equal">
                                            <div class="ribbon-lotto"><i class="fa fa-star-o"></i></div>

                                            <div class="lotto-head lotto-government">
                                                <h5>หวยรัฐบาลไทย</h5>
                                                <span class="badge badge-dark">ปิดรับ {{ formatDate(gov_round.expiration_date) }}</span>
                                            </div>

                                            <div class="lotto-time text-success time-government">
                                                <i class="fa fa-clock-o"></i>
                                                <span class="countdown">{{ printDay(scope.props.days) }}{{ scope.props.hours }}:{{ scope.props.minutes }}:{{ scope.props.seconds }}</span>
                                            </div>
                                        </div>
                                    </router-link>
                                </template>

                                <template slot="end-text" slot-scope="scope">
                                    <a href="#">
                                        <div class="lotto-card lotto-close lotto-card--equal">
                                            <div class="ribbon-lotto"><i class="fa fa-star-o"></i></div>

                                            <div class="lotto-head lotto-government">
                                                <h5>หวยรัฐบาลไทย</h5>
                                                <span class="badge badge-dark">ปิดรับ {{ formatDate(gov_round.expiration_date) }}</span>
                                            </div>

                                            <div class="lotto-time time-government">
                                                <i class="fa fa-ban"></i>
                                                <span>ปิดรับแทง</span>
                                            </div>
                                        </div>
                                    </a>
                                </template>
                            </vue-countdown-timer>

                            <a href="#" v-else>
                                <div class="lotto-card lotto-close lotto-card--equal">
                                    <div class="ribbon-lotto"><i class="fa fa-star-o"></i></div>

                                    <div class="lotto-head lotto-government">
                                        <h5>หวยรัฐบาลไทย</h5>
                                        <span>&nbsp;</span>
                                    </div>

                                    <div class="lotto-time time-government">
                                        <i class="fa fa-ban"></i>
                                        <span>ยังไม่รับแทง</span>
                                    </div>
                                </div>
                            </a>
                        </div>

                        <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 lotto-type-box">
                            <router-link :to="{ name: 'allyeekee' }">
                                <div class="lotto-card lotto-card--equal">
                                    <div class="ribbon-lotto ribbon-lotto--gold"><i class="fa fa-trophy"></i></div>

                                    <div class="lotto-head lotto-yeekee">
                                        <h5>จับยี่กี</h5>
                                        <span class="badge badge-dark">เปิดแทง 88 รอบ</span>
                                    </div>

                                    <div class="lotto-time">
                                        <div class="txt-24">
                                            <i class="fa fa-sun-o"></i>
                                            <span id="offset">24 ชม.</span>
                                        </div>
                                    </div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>

                <div class="lotto-section xtarget col-lotto">
                    <div class="section-title-wrap">
                        <h3 class="section-title">หวยหุ้น</h3>
                    </div>

                    <div class="row">
                        <div
                            class="col-xs-6 col-sm-6 col-md-3 col-lg-3 lotto-type-box"
                            v-for="(item, index) in indexes_round"
                            :key="'indexes-' + index"
                        >
                            <vue-countdown-timer
                                :start-time="item.start_time"
                                :end-time="item.end_time"
                                :show-zero="false"
                                :interval="1000"
                                v-if="item.status"
                            >
                                <template slot="countdown" slot-scope="scope">
                                    <router-link :to="{ name: getRouteName(item.round), params: { round: item.round } }">
                                        <div class="lotto-card lotto-card--equal">
                                            <div class="ribbon-lotto">
                                                <span :class="['flag-icon', 'flag-icon-' + getIndexCode(item.round)]"></span>
                                            </div>

                                            <div :class="['lotto-head', 'lotto-' + getIndexClass(item.round)]">
                                                <h5>{{ item.description }}</h5>
                                                <span class="badge badge-dark">ปิดรับ {{ formatDate(item.end_time) }}</span>
                                            </div>

                                            <div class="lotto-time text-success">
                                                <i class="fa fa-clock-o"></i>
                                                <span class="countdown">{{ scope.props.hours }}:{{ scope.props.minutes }}:{{ scope.props.seconds }}</span>
                                            </div>
                                        </div>
                                    </router-link>
                                </template>

                                <template slot="end-text" slot-scope="scope">
                                    <a href="#">
                                        <div class="lotto-card lotto-close lotto-card--equal">
                                            <div class="ribbon-lotto">
                                                <span :class="['flag-icon', 'flag-icon-' + getIndexCode(item.round)]"></span>
                                            </div>

                                            <div :class="['lotto-head', 'lotto-' + getIndexClass(item.round)]">
                                                <h5>{{ item.description }}</h5>
                                                <span class="badge badge-dark">ปิดรับ {{ formatDate(item.end_time) }}</span>
                                            </div>

                                            <div class="lotto-time text-success">
                                                <i class="fa fa-ban"></i>
                                                <span>ปิดรับแทง</span>
                                            </div>
                                        </div>
                                    </a>
                                </template>
                            </vue-countdown-timer>

                            <a href="#" v-else>
                                <div class="lotto-card lotto-off lotto-card--equal">
                                    <div class="ribbon-lotto">
                                        <span :class="['flag-icon', 'flag-icon-' + getIndexCode(item.round)]"></span>
                                    </div>

                                    <div :class="['lotto-head', 'lotto-' + getIndexClass(item.round)]">
                                        <h5>{{ item.description }}</h5>
                                        <span class="badge badge-dark">ปิดรับ {{ formatDate(item.end_time) }}</span>
                                    </div>

                                    <div class="lotto-time text-success">
                                        <i class="fa fa-ban"></i>
                                        <span>ปิด</span>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import moment from 'moment'

export default {
    name: 'lottery',
    data () {
        return {
            gov_round: {},
            indexes_round: [],
            start_time: '',
            indexes_start_time: {},
            indexes_end_time: {},

            mapping_flag: {
                1: "us",
                2: "jp",
                3: "jp",
                4: "cn",
                5: "cn ",
                6: "hk",
                7: "hk",
                8: "tw",
                9: "sg",
                10: "in",
                11: "eg",
                12: "ru",
                13: "de",
                14: "gb",
                15: "vn",
                16: "kr",
                17: "my",
                18: "la",
                22: "th",
                23: "vn",
                24: "vn",
                25: "gsb",
                26: "baac",
                27: "vn",
                28: "la",
                29: "la",
                30: "la",
            },

            site_name: '',
            marquee_text: 'เว็บหวยออนไลน์ที่ดีที่สุด ยินดีต้อนรับค่ะ',
            marquee_array: [
                'ยินดีต้อนรับสู่',
                'เว็บหวยออนไลน์ที่ดีที่สุด สมาชิกที่มีปัญหาในการใช้งาน สามารถกดปุ่มไลน์เพื่อแจ้งปัญหาหรือสอบถามข้อมูลได้ค่ะ',
            ],
        }
    },
    computed: {
        ...mapState({
            user: state => state.user.user,
            round: state => state.round.round,
            informations: state => state.information.informations
        }),
        ...mapGetters('information', ['getInformationCount', 'getAnnouceRecord', 'getMarqueeText']),
    },
    methods: {
        async loadRound () {
            try {
                this.start_time = moment()

                const response = await this.$store.dispatch('round/getRoundByType', 3)
                this.indexes_round = response

                const gov_response = await this.$store.dispatch('round/getRoundByType', 2)
                this.gov_round = gov_response
            } catch (error) {
                this.$toasted.error('There was an error connecting to the server.')
            }
        },

        formatDate (value) {
            if (value) {
                return moment(value).format('HH:mm')
            }
        },

        startCallBack: function (x) {
            console.log('startCallBack', x)
        },

        endCallBack: function (x) {
            console.log('endCallBack', x)
        },

        printDay (day) {
            let day_text = ''
            if (day > 0) {
                day_text = parseInt(day, 10) + 'วัน'
            }
            return day_text
        },

        getIndexCode (round) {
            return this.mapping_flag[round]
        },

        getIndexClass (round) {
            if (round == 22) {
                return 'thaistock'
            } else if (round == 23) {
                return 'vn-sp'
            } else if (round == 24) {
                return 'vn-sp'
            } else if (round == 25) {
                return 'th-gsb'
            } else if (round == 26) {
                return 'th-baac'
            } else if (round == 27) {
                return 'vn-sp'
            } else if (round == 15) {
                return 'vn-sp'
            }

            return this.mapping_flag[round]
        },

        getRouteName (round) {
            return (round == 25 || round == 26) ? 'spindex' : 'index'
        },
    },
    mounted () {
        this.site_name = process.env.VUE_APP_SITE

        if (typeof this.getMarqueeText !== 'undefined') {
            this.marquee_text = this.getMarqueeText.header
        }
    },
    created () {
        this.loadRound()
    },
    destroyed () {
    }
}
</script>

<style lang="css" scoped>
.main-content {
    margin-top: 0;
    border-radius: 0;
}

.lottery-page {
    background:
        radial-gradient(circle at top left, rgba(42, 110, 107, 0.07), transparent 24%),
        radial-gradient(circle at bottom right, rgba(26, 79, 75, 0.05), transparent 24%),
        linear-gradient(180deg, #eef3f2 0%, #e8eeee 100%);
}

/* ===== announce bar ===== */
.announce-bar {
    margin-top: 14px;
    margin-bottom: 18px;
}

.announce-bar__inner {
    display: flex;
    align-items: center;
    gap: 12px;
    background: #fff;
    border: 1px solid rgba(26, 79, 75, 0.08);
    border-radius: 0 0 28px 28px;
    padding: 14px 18px;
    box-shadow: 0 12px 28px rgba(26, 79, 75, 0.08);
}

.announce-bar__label {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    color: #1A4F4B;
    font-weight: 800;
    font-size: 15px;
    line-height: 1;
}

.announce-bar__label i {
    font-size: 22px;
}

.announce-bar__ticker {
    position: relative;
    flex: 1;
    overflow: hidden;
    min-width: 0;
    height: 22px;
    display: flex;
    align-items: center;
}

.announce-bar__track {
    display: inline-flex;
    align-items: center;
    white-space: nowrap;
    will-change: transform;
    animation: ticker-loop 18s linear infinite;
}

.announce-bar__track span {
    display: inline-block;
    padding-right: 80px;
    color: #e1453e;
    font-size: 14px;
    font-weight: 700;
    line-height: 1;
}

@keyframes ticker-loop {
    0% { transform: translateX(0); }
    100% { transform: translateX(-50%); }
}

/* ===== utility ===== */
.p-2 {
    padding: 0.5rem !important;
}

.w-100 {
    width: 100% !important;
}

.align-self-stretch {
    -ms-flex-item-align: stretch !important;
    align-self: stretch !important;
}

.text-success {
    color: #1A4F4B !important;
}

.text-white {
    color: #fff !important;
}

.bg-black {
    background-image: linear-gradient(#1A4F4B, #0d2e2b) !important;
}

.shadow-sm {
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

/* ===== layout ===== */
.lottery-content {
    background: transparent;
}

.col-lotto {
    margin-bottom: 22px;
}

.lotto-section {
    position: relative;
    overflow: hidden;
    padding: 18px 14px 12px;
    border-radius: 30px;

    background: linear-gradient(
        135deg,
        #1A4F4B 0%,
        #235E59 60%,
        #2A6E6B 100%
    );

    box-shadow: 0 16px 34px rgba(26, 79, 75, 0.18);
}

.lotto-section::before {
    content: "";
    position: absolute;
    width: 180px;
    height: 180px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.055);
    top: -40px;
    right: -38px;
    pointer-events: none;
}

.lotto-section::after {
    content: "";
    position: absolute;
    width: 140px;
    height: 140px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.035);
    left: -54px;
    bottom: -60px;
    pointer-events: none;
}

.section-title-wrap {
    position: relative;
    z-index: 1;
    margin-bottom: 12px;
    padding: 0 6px;
}

.section-title {
    margin: 0;
    color: #fff;
    font-size: 29px;
    font-weight: 900;
    line-height: 1;
    letter-spacing: -0.35px;
}

.row {
    position: relative;
    z-index: 1;
    display: flex;
    flex-wrap: wrap;
    margin-right: -5px;
    margin-left: -5px;
}

.lotto-type-box {
    padding-right: 5px !important;
    padding-left: 5px !important;
    margin-bottom: 10px;
}

a,
a:hover,
a:focus {
    text-decoration: none;
}

/* ===== card base ===== */
.lotto-card {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow: hidden;
    border-radius: 24px;
    border: 2px solid rgba(255, 255, 255, 0.72);
    background: linear-gradient(180deg, #ffffff 0%, #f8fbfb 100%);
    box-shadow: 0 10px 22px rgba(26, 79, 75, 0.12);
    transition: transform 0.18s ease, box-shadow 0.18s ease, opacity 0.18s ease, filter 0.18s ease;
}

.lotto-card--equal {
    height: 150px;
}

a:hover .lotto-card,
a:focus .lotto-card {
    transform: translateY(-2px);
    box-shadow: 0 16px 28px rgba(26, 79, 75, 0.14);
}

/* ===== enable / disable contrast ===== */
.lotto-card:not(.lotto-close):not(.lotto-off) {
    border-color: rgba(255, 255, 255, 0.92);
    box-shadow:
        0 12px 24px rgba(26, 79, 75, 0.14),
        inset 0 1px 0 rgba(255,255,255,0.10);
}

.lotto-close,
.lotto-off {
    opacity: 0.78;
    filter: saturate(0.68) brightness(0.96);
    border-color: rgba(220, 235, 234, 0.68);
    box-shadow: 0 6px 14px rgba(26, 79, 75, 0.06);
}

.lotto-close .lotto-head,
.lotto-off .lotto-head {
    color: rgba(255,255,255,0.76);
}

.lotto-close .badge-dark,
.lotto-off .badge-dark {
    background: rgba(42, 80, 78, 0.32);
    color: rgba(255,255,255,0.88);
}

.lotto-close .lotto-time,
.lotto-off .lotto-time {
    background: linear-gradient(180deg, #eef5f5 0%, #e7f0f0 100%);
    color: #2a6e6b;
    border-top-color: #cfe0df;
}

.lotto-close .ribbon-lotto,
.lotto-off .ribbon-lotto {
    background: rgba(255, 255, 255, 0.10);
    color: rgba(255,255,255,0.84);
}

/* ===== top-right icon bubble ===== */
.ribbon-lotto {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 2;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 50px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.16);
    color: #ffffff;
    backdrop-filter: blur(2px);
    box-shadow:
        inset 0 1px 0 rgba(255,255,255,0.16),
        0 2px 6px rgba(0,0,0,0.08);
    font-size: 17px;
}

.ribbon-lotto--gold {
    background: linear-gradient(180deg, #f7e08a 0%, #d4a62a 55%, #b98412 100%);
    color: #fff8dc;
    border: 1px solid rgba(255, 224, 130, 0.78);
    box-shadow:
        0 8px 18px rgba(185, 132, 18, 0.28),
        inset 0 1px 0 rgba(255,255,255,0.35);
}

.flag-icon {
    transform: scale(1.3);
}

/* ===== head ===== */
.lotto-head {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    flex: 1 1 auto;
    min-height: 94px;
    padding: 13px 12px 10px;
    color: #fff;
    text-align: left;
    text-shadow: rgba(0, 0, 0, 0.10) 0 1px 1px;
}

.lotto-head h5 {
    margin: 0 34px 8px 0;
    font-size: 13px;
    font-weight: 800;
    line-height: 1.24;
    min-height: 32px;
    letter-spacing: -0.2px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-break: break-word;
}

/* ===== badge ===== */
.badge-dark {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 24px;
    color: #ffffff;
    background: rgba(26, 79, 75, 0.28);
    border: 1px solid rgba(255, 255, 255, 0.14);
    border-radius: 999px !important;
    font-family: unset !important;
    font-size: 13px;
    font-weight: 800;
    padding: 5px 12px;
    line-height: 1;
    box-shadow: inset 0 1px 0 rgba(255,255,255,0.06);
    letter-spacing: 0.1px;
}

/* ===== footer ===== */
.lotto-time {
    min-height: 44px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 8px 11px;
    background: linear-gradient(180deg, #ffffff 0%, #f8fcfc 100%);
    border-top: 1px solid #cfe0df;
    font-size: 12px;
    line-height: 1.1;
    color: #1A4F4B;
    font-weight: 800;
}

.lotto-time i {
    flex-shrink: 0;
    font-size: 14px;
    opacity: 0.95;
}

.lotto-time span {
    display: inline-block;
    line-height: 1;
}

.countdown {
    font-size: 16px;
    font-weight: 900;
    letter-spacing: 0.25px;
}

.time-government {
    color: #1A4F4B;
}

.txt-24 {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #1A4F4B;
    font-size: 12px;
    font-weight: 900;
    line-height: 1;
}

.txt-24 i {
    font-size: 14px;
}

/* ===== open card color ===== */
.lotto-government {
    background:
        linear-gradient(135deg, rgba(255,255,255,0.07), rgba(255,255,255,0)),
        linear-gradient(135deg, #235E59 0%, #2A6E6B 100%);
}

.lotto-yeekee {
    background:
        linear-gradient(135deg, rgba(255,255,255,0.06), rgba(255,255,255,0)),
        linear-gradient(135deg, #2A8C87 0%, #1A6B66 100%);
}

.lotto-us,
.lotto-jp,
.lotto-cn,
.lotto-hk,
.lotto-tw,
.lotto-sg,
.lotto-in,
.lotto-eg,
.lotto-ru,
.lotto-de,
.lotto-gb,
.lotto-kr,
.lotto-my,
.lotto-la,
.lotto-thaistock,
.lotto-th,
.lotto-vn-vip,
.lotto-vn-sp,
.lotto-vn-spf,
.lotto-la-str,
.lotto-la-sup,
.lotto-la-har,
.lotto-th-gsb,
.lotto-th-baac {
    background:
        linear-gradient(135deg, rgba(255,255,255,0.05), rgba(255,255,255,0)),
        linear-gradient(135deg, #1A4F4B 0%, #0d2e2b 100%);
}

/* ===== disabled card color separation ===== */
.lotto-close .lotto-government,
.lotto-off .lotto-government {
    background:
        linear-gradient(135deg, rgba(255,255,255,0.03), rgba(255,255,255,0)),
        linear-gradient(135deg, #4a7b78 0%, #5a8a87 100%);
}

.lotto-close .lotto-yeekee,
.lotto-off .lotto-yeekee,
.lotto-close .lotto-us,
.lotto-off .lotto-us,
.lotto-close .lotto-jp,
.lotto-off .lotto-jp,
.lotto-close .lotto-cn,
.lotto-off .lotto-cn,
.lotto-close .lotto-hk,
.lotto-off .lotto-hk,
.lotto-close .lotto-tw,
.lotto-off .lotto-tw,
.lotto-close .lotto-sg,
.lotto-off .lotto-sg,
.lotto-close .lotto-in,
.lotto-off .lotto-in,
.lotto-close .lotto-eg,
.lotto-off .lotto-eg,
.lotto-close .lotto-ru,
.lotto-off .lotto-ru,
.lotto-close .lotto-de,
.lotto-off .lotto-de,
.lotto-close .lotto-gb,
.lotto-off .lotto-gb,
.lotto-close .lotto-kr,
.lotto-off .lotto-kr,
.lotto-close .lotto-my,
.lotto-off .lotto-my,
.lotto-close .lotto-la,
.lotto-off .lotto-la,
.lotto-close .lotto-thaistock,
.lotto-off .lotto-thaistock,
.lotto-close .lotto-th,
.lotto-off .lotto-th,
.lotto-close .lotto-vn-vip,
.lotto-off .lotto-vn-vip,
.lotto-close .lotto-vn-sp,
.lotto-off .lotto-vn-sp,
.lotto-close .lotto-vn-spf,
.lotto-off .lotto-vn-spf,
.lotto-close .lotto-la-str,
.lotto-off .lotto-la-str,
.lotto-close .lotto-la-sup,
.lotto-off .lotto-la-sup,
.lotto-close .lotto-la-har,
.lotto-off .lotto-la-har,
.lotto-close .lotto-th-gsb,
.lotto-off .lotto-th-gsb,
.lotto-close .lotto-th-baac,
.lotto-off .lotto-th-baac {
    background:
        linear-gradient(135deg, rgba(255,255,255,0.03), rgba(255,255,255,0)),
        linear-gradient(135deg, #3a6b68 0%, #4a7b78 100%);
}

@media (min-width: 768px) {
    .lotto-card--equal {
        height: 132px;
    }

    .lotto-head {
        min-height: 96px;
    }
}

@media (max-width: 767px) {
    .announce-bar {
        margin-top: 12px;
        margin-bottom: 14px;
    }

    .announce-bar__inner {
        padding: 12px 16px;
        border-radius: 0 0 26px 26px;
    }

    .announce-bar__label {
        font-size: 13px;
    }

    .announce-bar__label i {
        font-size: 20px;
    }

    .announce-bar__ticker {
        height: 22px;
    }

    .announce-bar__track span {
        font-size: 13px;
        padding-right: 64px;
    }

    .lotto-section {
        padding: 16px 10px 10px;
        border-radius: 28px;
    }

    .section-title-wrap {
        margin-bottom: 10px;
        padding: 0 8px;
    }

    .section-title {
        font-size: 28px;
    }

    .lotto-type-box {
        padding-right: 4px !important;
        padding-left: 4px !important;
        margin-bottom: 8px;
    }

    .lotto-card {
        border-radius: 22px;
    }

    .lotto-card--equal {
        height: 150px;
    }

    .ribbon-lotto {
        width: 38px;
        height: 38px;
        top: 10px;
        right: 10px;
        font-size: 16px;
    }

    .lotto-head {
        min-height: 94px;
        padding: 13px 12px 10px;
    }

    .lotto-head h5 {
        margin-right: 34px;
        margin-bottom: 8px;
        font-size: 15px;
        min-height: 32px;
    }

    .badge-dark {
        font-size: 9px;
        padding: 5px 12px;
    }

    .lotto-time {
        min-height: 44px;
        padding: 8px 11px;
        font-size: 12px;
    }

    .lotto-time i {
        font-size: 14px;
    }

    .countdown {
        font-size: 16px;
    }

    .txt-24 {
        font-size: 12px;
    }

    .txt-24 i {
        font-size: 14px;
    }
}
</style>